import { useQuery } from "@tanstack/react-query";
import leadsService from "services/admin/leadsService";

export const useGetLead = (leadID) => {
    return useQuery({
        queryKey: ['lead', leadID],
        queryFn: async () => {
            const { data } = await leadsService.get(leadID)
            return data
        },
        refetchOnWindowFocus: false,
        enabled: !!leadID,
    })
}